var _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse2, _rect11, _rect12, _rect13, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPayServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 109,
    viewBox: "0 0 131 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.3018,
    y: 38.7471,
    width: 79.9229,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4238,
    y: 49.3252,
    width: 78.6561,
    height: 23.5119,
    rx: 11.756,
    transform: "rotate(-35 10.4238 49.3252)",
    fill: "#EEC2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3018,
    y: 55.5723,
    width: 92.5423,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3018,
    y: 72.3984,
    width: 84.1293,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3018,
    y: 89.2246,
    width: 75.7164,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7142,
    cy: 70.295,
    rx: 33.6517,
    ry: 35.755,
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2998,
    y: 34.5381,
    width: 79.9229,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4238,
    y: 45.1162,
    width: 78.6561,
    height: 23.5119,
    rx: 11.756,
    transform: "rotate(-35 10.4238 45.1162)",
    fill: "#FFDCD5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2998,
    y: 51.3633,
    width: 92.5423,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2998,
    y: 68.1895,
    width: 84.1293,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2998,
    y: 85.0156,
    width: 75.7164,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7142,
    cy: 66.086,
    rx: 33.6517,
    ry: 35.755,
    fill: "#FFDCD5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1582,
    y: 30.3311,
    width: 84.1417,
    height: 49.8618,
    fill: "#00C968"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1582,
    y: 30.377,
    width: 28.0472,
    height: 49.8618,
    fill: "#A4EECB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1875,
    y: 36.6094,
    width: 49.8618,
    height: 37.3963,
    fill: "#A4EECB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6395 72.5537L52.7796 65.3828H50.4042V63.478H52.2866L50.4266 56.3295H52.8244L54.5275 63.478H57.3959L59.1886 56.3295H61.6536L63.4463 63.478H66.3147L68.0178 56.3295H70.4155L68.5556 63.478H70.4379V65.3828H68.0626L66.1802 72.5537H63.7152L61.8553 65.3828H58.9869L57.127 72.5537H54.6395ZM54.9981 65.3828L55.8496 68.9907H56.0065L56.9253 65.3828H54.9981ZM59.5023 63.478H61.3623L60.4883 60.1391H60.3539L59.5023 63.478ZM63.9393 65.3828L64.8357 69.0131H64.9701L65.8441 65.3828H63.9393Z",
    fill: "#00C968"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcPayServiceBodyMobile.e72b639619c5f4d97b7cce638f190cd7.svg";
export { ForwardRef as ReactComponent };